export default function noop() {}

export const promiseNoop = (_: number, __: number) => Promise.resolve();
